import { useEffect, useState } from "react";
import useServices from "../hooks/useServices";

const ServicesSelect = ({ data, setData, name, defaultValue, multiple }) => {

    const [currentValue, setCurrentValue] = useState(null);

    const [currentServices, setCurrentServices] = useState([]);

    const [allServices, setAllServices] = useState(false);

    const [filters, setFilters] = useState({
        name: '',
        page: 1,
        orderBy: 'name,ASC',
        perPage: 10
    });

    const [{ services, numberOfPages: servicesNumberOfPages, loading: loadingServices }] = useServices({ params: filters }, { useCache: false });

    useEffect(() => {
        if (allServices) {
            setData(old => ({ ...old, [name]: services?.map(service => service?.id) }))
        } else {
            setData(old => ({ ...old, [name]: [] }))
        }
    }, [allServices])

    useEffect(() => {
        if (defaultValue) {
            setCurrentValue(defaultValue);
        }
    }, [defaultValue])

    useEffect(() => {
        setCurrentServices((old) => [...old, ...services]);
    }, [services])

    const handleService = (service) => {
        if (multiple) {
            const dataToSet = data[name]?.includes(service?.id) ? data[name].filter(id => id !== service?.id) : [...data[name], service?.id];
            setData(old => ({ ...old, [name]: dataToSet }));
        }
        else {
            setCurrentValue(service);
            setData(old => ({ ...old, [name]: service?.id }))
        }
    }

    return (
        <div className="form-group mb-3 col-md-12 mt-4">
            <div className="row align-items-center justify-content-between">
                <div className="col-md-8 mb-3">
                    <h6>Servicios</h6>
                </div>
                <div className="col-md-4">
                    <input placeholder="Buscar" type="text" className="form-control" onChange={(e) => {
                        setCurrentServices([]);
                        setFilters(old => ({ ...old, name: e.target.value, page: 1 }));
                    }} />
                </div>
            </div>
            <div className="form-check form-check-inline">
                <label className="form-check-label">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        name="serviceIds"
                        checked={allServices}
                        onChange={() => setAllServices(!allServices)}
                    />
                    Seleccionar todos
                </label>
            </div>
            <div className="row">
                {
                    currentServices?.map((service) => {
                        return (
                            <div className="col-md-3" key={`servicio-${service?.id}`}>
                                <div className="form-check form-check-inline">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            value={service?.id}
                                            checked={multiple ? data?.[name]?.includes(service?.id) : data?.[name] === service?.id}
                                            onChange={() => handleService(service)}
                                        />
                                        {service?.name}
                                    </label>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    loadingServices ?
                        <div className="col-md-12 my-3 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    !loadingServices && servicesNumberOfPages > filters?.page ?
                        <div className="col-md-12 text-center">
                            <button
                                onClick={() => setFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                type="button"
                                className="btn btn-primary mx-1"
                            >
                                Cargar más
                            </button>
                            <button
                                onClick={() => {
                                    setCurrentServices([]);
                                    setFilters((old) => ({ ...old, page: 1, perPage: null }));
                                }}
                                type="button"
                                className="btn btn-primary mx-1"
                            >
                                Cargar Todos
                            </button>
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}


export default ServicesSelect;